import {createApi} from "@reduxjs/toolkit/query/react";
import {createBaseQuery} from "../../utils/apiUtils";
import GlobalConst from "../../constants/GlobalConst";

export const pickXApi = createApi({
    reducerPath: "pickXApi",

    baseQuery: createBaseQuery(),
    endpoints: (builder) => ({

        getPreSelectedParlaysLobbyData: builder.query({
            query: ()=>({
                url: `Parlays/Lobby?currency=${GlobalConst.SITE_CURRENCY}`,
                method: "GET"
            })
        }),

        getPreSelectedParlayById: builder.query({
            query: (id) => ({
                url: `Parlays/PreSelected/${id}`,
                method: "GET"
            })
        }),

        getContestsLobbyData: builder.query({
            query: () => ({
                url: `Contests/Lobby`,
                method: "GET"
            })
        }),

        getContestsByIds: builder.query({
            query: (ids) => ({
                url: `Contests/ByIds`,
                method: "POST",
                body: ids
            })
        }),

        getActiveUserParlays: builder.query({
            query: () => ({
                url: `Parlays/Active`,
                method: "GET"
            })
        }),

        getUserParlaysHistory: builder.query({
            query: (minDate) => ({
                url: `Parlays/History?minDate=${minDate}`,
                method: "GET"
            })
        }),

        submitParlay: builder.mutation({
            query: (cmd) => {
                return {
                url: `Parlays/Submit`,
                method: "POST",
                body: cmd
            }}
        }),

        getRollingPrize: builder.query({
            query: ({ currency, wager, sportId, payoutModel }) => ({
                url: `Parlays/RollingPrize`,
                method: "GET",
                params: { currency, wager, sportId, payoutModel }, // This will append query parameters
            }),
        }),

        getNextAvailableP12ByLeague: builder.query({
            query: (league) => ({
                url: `Parlays/NextAvailableP12/${league}?siteTLD=${GlobalConst.SITE_TLD}`,
                method: "GET"
            })
        }),

        getPrizeAssetById: builder.query({
            query: (id) => ({
                url: `Parlays/PrizeAssets/${id}`,
                method: "GET"
            })
        }),
        getWinningPrizeAssets: builder.query({
            query: ()=>({
                url: `Parlays/WinningPrizeAssets`,
                method: "GET"
            })
        }),

        ///
        isGeoRestricted: builder.query({
            query: () => ({
                url: `Security/IsGeoRestricted`,
                method: "GET"
            })
        }),

        isLocationAndRestrictions: builder.query({
            query: () => ({
                url: `Security/LocationAndRestrictions`,
                method: "GET"
            })
        }),


    })
});

export const {
    useGetContestsLobbyDataQuery,
    useGetPreSelectedParlaysLobbyDataQuery,
    useGetContestsByIdsQuery,
    useGetRollingPrizeQuery,
    useGetActiveUserParlaysQuery,
    useGetUserParlaysHistoryQuery,
    useIsGeoRestrictedQuery,
    useIsLocationAndRestrictionsQuery,
    useGetNextAvailableP12ByLeagueQuery,
    useGetPrizeAssetByIdQuery,
    useGetWinningPrizeAssetsQuery
} = pickXApi;


export default pickXApi;